import React from "react";
import { CartesianGrid, Legend, Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";

const PAL = ["#F97316", "#1D4ED8", "#16A34A", "#DC2626", "#9333EA", "#0891B2"];

export const WeeklyChart = ({ chart }) => {
  if (!chart?.series?.length) return <p className="mb-3 text-xs text-slate-400" data-testid="weekly-chart-empty">Sem consumo confirmado nas últimas 8 semanas para montar o gráfico.</p>;
  const data = chart.weeks.map((w, i) => Object.fromEntries([["week", w], ...chart.series.map((s) => [`${s.name} (${s.unit})`, s.values[i]])]));
  return (
    <div className="mb-4 h-72 w-full" data-testid="weekly-chart">
      <h4 className="mb-1 text-sm font-bold text-slate-700">Consumo por semana — 6 alimentos mais consumidos</h4>
      <ResponsiveContainer width="100%" height="90%">
        <LineChart data={data} margin={{ left: -10, right: 10, top: 5 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="#e2e8f0" />
          <XAxis dataKey="week" tick={{ fontSize: 11 }} />
          <YAxis tick={{ fontSize: 11 }} />
          <Tooltip formatter={(v) => Number(v).toLocaleString("pt-BR")} />
          <Legend wrapperStyle={{ fontSize: 11 }} />
          {chart.series.map((s, i) => <Line key={s.food_id} type="monotone" dataKey={`${s.name} (${s.unit})`} stroke={PAL[i]} strokeWidth={2} dot={{ r: 3 }} />)}
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};
